/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const pin_code = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10.333 3.583V1.75a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v12.667a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3.334M4.06 7.243h.347m3.153 0h.346m3.154 0h.346m3.153 0h.346m-10.42 0c0 .183-.16.243-.247.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm3.5 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm3.5 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm3.5 0c0 .183-.16.243-.249.243-.091 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    />
  </svg>
)
export default pin_code
